/* SK Gift Options - popup regalo en carrito */

(function () {
  'use strict';

  var DIALOG_ID = 'sk-gift-dialog';
  var variantIdCache = null;
  var productDataCache = null;

  /* --- Utilidades API --- */

  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) { return r.json(); });
  }

  function getCart() {
    return fetchJSON('/cart.js');
  }

  function updateCartAttributes(attrs) {
    return fetchJSON('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  function addToCart(variantId, qty) {
    return fetchJSON('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    });
  }

  function changeCartItem(key, qty) {
    return fetchJSON('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  /* --- Resolver variant ID del producto caja-regalo --- */

  function getGiftProductData(handle) {
    if (productDataCache) {
      return Promise.resolve(productDataCache);
    }
    return fetchJSON('/products/' + handle + '.js').then(function (data) {
      productDataCache = data;
      variantIdCache = data.variants[0].id;
      return data;
    });
  }

  /* --- Buscar item caja-regalo en el carrito --- */

  function findGiftBoxInCart(cart, handle) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].handle === handle) {
        return cart.items[i];
      }
    }
    return null;
  }

  /* --- Normalizar URL de imagen (Shopify devuelve //cdn... sin protocolo) --- */

  function normalizeImageUrl(url, width) {
    if (!url) return '';
    var src = url.indexOf('//') === 0 ? 'https:' + url : url;
    if (width) {
      src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }
    return src;
  }

  /* --- Escapar texto para inyectar en innerHTML / atributos --- */

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* --- Crear dialog HTML --- */

  function createDialog(maxLength, giftName, giftPrice) {
    var existing = document.getElementById(DIALOG_ID);
    if (existing) return existing;

    var dialog = document.createElement('dialog');
    dialog.id = DIALOG_ID;
    dialog.className = 'sk-gift__dialog';

    dialog.innerHTML =
      '<div class="sk-gift__header">' +
        '<span class="sk-gift__title">Opciones de regalo</span>' +
        '<button type="button" class="sk-gift__close" data-gift-close aria-label="Cerrar">&times;</button>' +
      '</div>' +
      '<label class="sk-gift__field-label" for="sk-gift-message">Mensaje personalizado</label>' +
      '<textarea id="sk-gift-message" class="sk-gift__textarea" data-gift-message placeholder="Escribe tu mensaje..." maxlength="' + maxLength + '"></textarea>' +
      '<div class="sk-gift__counter" data-gift-counter>' +
        '<span>Máximo ' + maxLength + ' caracteres</span>' +
        '<span data-gift-count>0 / ' + maxLength + '</span>' +
      '</div>' +
      '<hr class="sk-gift__separator">' +
      '<p class="sk-gift__radio-title">Tipo de envoltorio</p>' +
      '<div class="sk-gift__radio-group">' +
        '<label class="sk-gift__radio-label">' +
          '<input type="radio" name="sk-gift-packaging" value="estandar" checked>' +
          '<span class="sk-gift__radio-text">Packaging estándar</span>' +
          '<span class="sk-gift__radio-price">Gratis</span>' +
        '</label>' +
        '<label class="sk-gift__radio-label">' +
          '<input type="radio" name="sk-gift-packaging" value="caja-regalo">' +
          '<span class="sk-gift__radio-text">' + escapeHtml(giftName) + '</span>' +
          '<span class="sk-gift__radio-price">+' + escapeHtml(giftPrice) + '</span>' +
        '</label>' +
      '</div>' +
      '<div class="sk-gift__box-preview" data-gift-preview hidden>' +
        '<img class="sk-gift__box-preview-img" data-gift-box-img src="" alt="' + escapeHtml(giftName) + '" loading="lazy" decoding="async">' +
      '</div>' +
      '<div class="sk-gift__actions">' +
        '<button type="button" class="sk-gift__btn sk-gift__btn--cancel" data-gift-close>Cancelar</button>' +
        '<button type="button" class="sk-gift__btn sk-gift__btn--save" data-gift-save>Guardar</button>' +
      '</div>';

    document.body.appendChild(dialog);
    return dialog;
  }

  /* --- Llenar dialog con datos actuales --- */

  function fillDialog(dialog, cart) {
    var attrs = cart.attributes || {};

    /* Reset boton guardar (por si quedo en 'Guardando...' tras un error previo) */
    var saveBtn = dialog.querySelector('[data-gift-save]');
    if (saveBtn) {
      saveBtn.classList.remove('sk-gift__btn--loading');
      saveBtn.textContent = 'Guardar';
    }

    /* Mensaje */
    var textarea = dialog.querySelector('[data-gift-message]');
    textarea.value = attrs.mensaje_regalo || '';
    updateCounter(dialog, textarea);

    /* Packaging */
    var tipo = attrs.tipo_packaging || 'estandar';
    var radios = dialog.querySelectorAll('input[name="sk-gift-packaging"]');
    for (var i = 0; i < radios.length; i++) {
      radios[i].checked = (radios[i].value === tipo);
    }

    /* Preview de la caja: visible solo si caja-regalo esta seleccionado */
    var preview = dialog.querySelector('[data-gift-preview]');
    if (preview) preview.hidden = (tipo !== 'caja-regalo');
  }

  /* --- Actualizar contador de caracteres --- */

  function updateCounter(dialog, textarea) {
    var maxLen = parseInt(textarea.getAttribute('maxlength'), 10);
    var currentLen = textarea.value.length;
    var countEl = dialog.querySelector('[data-gift-count]');
    var counterWrap = dialog.querySelector('[data-gift-counter]');

    countEl.textContent = currentLen + ' / ' + maxLen;

    if (currentLen >= maxLen) {
      counterWrap.classList.add('sk-gift__counter--over');
    } else {
      counterWrap.classList.remove('sk-gift__counter--over');
    }
  }

  /* --- Abrir dialog --- */

  function openGiftDialog(trigger) {
    var container = trigger.closest('[data-gift-handle]');
    var handle = container.dataset.giftHandle;
    var maxLen = parseInt(container.dataset.giftMaxLength, 10) || 240;
    var giftName = container.dataset.giftName || 'Caja regalo premium';
    var giftPrice = container.dataset.giftPrice || '4,00€';

    var dialog = createDialog(maxLen, giftName, giftPrice);

    /* Pre-cargar datos del producto y carrito en paralelo */
    Promise.all([getCart(), getGiftProductData(handle)]).then(function (results) {
      var cart = results[0];
      var data = results[1];
      fillDialog(dialog, cart);

      /* Setear imagen de la caja (idempotente: solo cambia si difiere) */
      var img = dialog.querySelector('[data-gift-box-img]');
      if (img && data && data.featured_image) {
        var src = normalizeImageUrl(data.featured_image, 240);
        if (img.src !== src) img.src = src;
      }

      dialog.showModal();
    });
  }

  /* --- Cerrar dialog --- */

  function closeDialog(dialog) {
    if (!dialog || !dialog.open) return;
    dialog.close();
  }

  /* --- Marcar visualmente los triggers de regalo segun el estado del carrito --- */
  function syncGiftActive(cart) {
    var on = !!(cart && cart.attributes && String(cart.attributes.es_regalo) === 'true');
    var triggers = document.querySelectorAll('[data-gift-open]');
    for (var i = 0; i < triggers.length; i++) {
      triggers[i].classList.toggle('is-gift-active', on);
      triggers[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  /* --- Refrescar carrito sin recargar: contadores + evento global --- */

  function refreshCart() {
    return getCart().then(function (cart) {
      /* Actualizar contadores del carrito */
      var counters = document.querySelectorAll('[data-cart-count]');
      for (var i = 0; i < counters.length; i++) counters[i].textContent = cart.item_count;

      /* Marcar el check de "regalo activado" en los triggers (drawer y /cart) */
      syncGiftActive(cart);

      /* Disparar cart:update para que el drawer (sk-cart-drawer-filled.js) y demas listeners se refresquen */
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, source: 'sk-gift-options', data: { itemCount: cart.item_count } }
      }));

      return cart;
    });
  }

  /* Mantener el check sincronizado cuando otros scripts actualizan el carrito */
  document.addEventListener('cart:update', function (e) {
    if (e && e.detail && e.detail.resource && e.detail.source !== 'sk-gift-options') {
      syncGiftActive(e.detail.resource);
    }
  });

  /* --- Mini-popup de confirmacion (usa <dialog> no-modal: tambien va al top layer y no se esconde tras el cart drawer) --- */

  function showToast(message, isError) {
    var toast = document.createElement('dialog');
    toast.className = 'sk-gift__toast' + (isError ? ' sk-gift__toast--error' : '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = message;
    document.body.appendChild(toast);

    try { toast.show(); } catch (e) { /* fallback: dialog API no disponible */ }

    /* Forzar reflow antes de aplicar la clase visible para que arranque la transicion */
    void toast.offsetHeight;
    toast.classList.add('sk-gift__toast--visible');

    setTimeout(function () {
      toast.classList.remove('sk-gift__toast--visible');
      setTimeout(function () {
        if (toast.open) toast.close();
        toast.remove();
      }, 350);
    }, 2200);
  }

  /* --- Guardar opciones --- */

  function saveGiftOptions(dialog) {
    var textarea = dialog.querySelector('[data-gift-message]');
    var selectedRadio = dialog.querySelector('input[name="sk-gift-packaging"]:checked');
    var saveBtn = dialog.querySelector('[data-gift-save]');
    var handle = document.querySelector('[data-gift-handle]').dataset.giftHandle;

    var mensaje = textarea.value.trim();
    var tipo = selectedRadio ? selectedRadio.value : 'estandar';
    var action = null; /* 'added' | 'removed' | null */

    /* Deshabilitar boton */
    saveBtn.classList.add('sk-gift__btn--loading');
    saveBtn.textContent = 'Guardando...';

    /* 1. Actualizar attributes */
    updateCartAttributes({
      es_regalo: 'true',
      mensaje_regalo: mensaje,
      tipo_packaging: tipo
    }).then(function () {
      return getCart();
    }).then(function (cart) {
      var giftItem = findGiftBoxInCart(cart, handle);

      if (tipo === 'caja-regalo') {
        /* Anadir caja si no esta */
        if (!giftItem) {
          action = 'added';
          return addToCart(variantIdCache, 1);
        }
      } else {
        /* Quitar caja si esta */
        if (giftItem) {
          action = 'removed';
          return changeCartItem(giftItem.key, 0);
        }
      }
    }).then(function () {
      /* Refrescar contadores y notificar al drawer para que se re-renderice sin recargar */
      return refreshCart();
    }).then(function () {
      closeDialog(dialog);
      var msg = 'Opciones de regalo guardadas';
      if (action === 'added') msg = 'Caja regalo añadida al carrito';
      else if (action === 'removed') msg = 'Caja regalo eliminada del carrito';
      showToast(msg, false);
    }).catch(function () {
      saveBtn.classList.remove('sk-gift__btn--loading');
      saveBtn.textContent = 'Guardar';
      showToast('No se pudo guardar. Inténtalo de nuevo.', true);
    });
  }

  /* --- Event delegation en document (sobrevive morph) --- */

  document.addEventListener('click', function (e) {
    /* Abrir dialog */
    var openBtn = e.target.closest('[data-gift-open]');
    if (openBtn) {
      e.preventDefault();
      openGiftDialog(openBtn);
      return;
    }

    /* Cerrar dialog */
    var closeBtn = e.target.closest('[data-gift-close]');
    if (closeBtn) {
      e.preventDefault();
      var dialog = document.getElementById(DIALOG_ID);
      closeDialog(dialog);
      return;
    }

    /* Guardar */
    var saveBtn = e.target.closest('[data-gift-save]');
    if (saveBtn) {
      e.preventDefault();
      var dlg = document.getElementById(DIALOG_ID);
      saveGiftOptions(dlg);
      return;
    }
  });

  /* Cerrar al hacer clic en backdrop */
  document.addEventListener('click', function (e) {
    var dialog = document.getElementById(DIALOG_ID);
    if (!dialog || !dialog.open) return;
    if (e.target === dialog) {
      closeDialog(dialog);
    }
  });

  /* Contador de caracteres en tiempo real */
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-gift-message]')) {
      var dialog = document.getElementById(DIALOG_ID);
      updateCounter(dialog, e.target);
    }
  });

  /* Toggle preview de la caja al cambiar de radio */
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('input[name="sk-gift-packaging"]')) return;
    var dialog = document.getElementById(DIALOG_ID);
    if (!dialog) return;
    var preview = dialog.querySelector('[data-gift-preview]');
    if (!preview) return;
    preview.hidden = !(e.target.checked && e.target.value === 'caja-regalo');
  });

  /* Cerrar con Escape (con animacion) */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var dialog = document.getElementById(DIALOG_ID);
      if (dialog && dialog.open) {
        e.preventDefault();
        closeDialog(dialog);
      }
    }
  });
})();
